import { render, staticRenderFns } from "./item_detail.vue?vue&type=template&id=b788b8e6&scoped=true"
import script from "./item_detail.vue?vue&type=script&lang=js"
export * from "./item_detail.vue?vue&type=script&lang=js"
import style0 from "./item_detail.vue?vue&type=style&index=0&id=b788b8e6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b788b8e6",
  null
  
)

export default component.exports